import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { findNestedObj } from '@/common/utils/index';

const Form = ({
  onFormStateChange = () => {},
  initialValues,
  validation,
  validationMode = 'onSubmit',
  reValidationMode = 'onSubmit',
  shouldUnregister = true,
  onSubmit,
  className,
  children,
  errors = [],
  formRef,
  ...props
}) => {
  const methods = useForm({
    mode: validationMode,
    reValidateMode: reValidationMode,
    resolver: validation ? yupResolver(validation) : undefined,
    shouldUnregister,
    defaultValues: initialValues,
  });
  const { isDirty, isValid } = methods.formState;

  const scrollToErrors = useCallback((errors) => {
    if (!errors) return;
    const values = Object.values(errors);
    console.log('errors', values);
    if (values.length > 0) {
      let element = values[0]?.value?.ref;
      if (!element && values[0]) {
        element = findNestedObj(values[0], 'ref')?.ref;
        console.log('errors2', element);
      }
      if (element) {
        let firstErr = document.getElementsByName(element.name)[0];
        firstErr.scrollIntoView({ behavior: `smooth`, block: 'center' });
      }
    }
  }, []);

  const handleSubmit = useCallback(
    methods.handleSubmit(async (form) => {
      await onSubmit(form);
    }, scrollToErrors),
    [onSubmit]
  );

  useEffect(() => {
    errors.forEach((error) => {
      methods.setError(...error);
    });
  }, [errors]);

  useEffect(() => {
    methods.reset(initialValues);
  }, [initialValues]);

  useEffect(() => {
    if (methods) {
      onFormStateChange(methods.formState, handleSubmit);
    }
  }, [isDirty, isValid]);

  useEffect(() => {
    if (!formRef) return;
    formRef.current = methods;
  }, []);

  return (
    <FormProvider {...methods}>
      <form className={className} onSubmit={handleSubmit} noValidate {...props}>
        {children}
      </form>
    </FormProvider>
  );
};

Form.propTypes = {
  initialValues: PropTypes.object,
  validation: PropTypes.object,
  validationMode: PropTypes.oneOf(['onChange', 'onSubmit', 'onBlur']),
  onSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default Form;
